function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m369.501 60h15v15h-15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m369.501 30h15v15h-15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m414.5 209.215v-209.215h-317.001v45h15v-30h287.001v279.219l-143.5 100.732-143.501-100.732v-234.219h-15v149.216l-59.999 42.928v237.356c0 12.406 10.093 22.5 22.5 22.5h317v-15h-317c-4.136 0-7.5-3.364-7.5-7.5v-219.072l143.26 100.563-73.323 53.133 8.802 12.146 77.506-56.164 47.255 33.171 47.255-33.171 75.945 55.032 8.802-12.146-71.761-52.001 143.259-100.563v219.072c0 4.136-3.364 7.5-7.5 7.5h-30v15h30c12.406 0 22.5-10.094 22.5-22.5v-237.356zm-317.001 74.474-39.528-27.747 39.528-28.282zm317.001-56.029 39.529 28.282-39.529 27.747z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392 497h15v15h-15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m347.306 129.943c8.106-26.331-3.314-55.135-26.565-67-10.932-5.579-23.022-6.594-34.963-2.938-10.654 3.262-20.64 10.028-29.777 20.158-9.137-10.129-19.123-16.895-29.776-20.157-11.942-3.659-24.032-2.641-34.963 2.938-23.25 11.866-34.671 40.669-26.565 67 11.648 37.835 40.357 68.544 87.77 93.882l3.535 1.889 3.535-1.889c47.411-25.339 76.121-56.048 87.769-93.883zm-91.306 78.733c-41.634-22.979-66.828-50.206-76.969-83.146-6.827-22.176 4.719-41.914 19.048-49.227 4.496-2.294 9.194-3.417 13.972-3.417 12.894 0 26.364 8.179 37.957 23.584l5.993 7.963 5.993-7.963c15.89-21.114 35.303-28.653 51.929-20.167 14.329 7.313 25.875 27.05 19.048 49.227-10.142 32.94-35.336 60.167-76.971 83.146z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m218.5 247.21h75v15h-75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m218.5 307.209h75v15h-75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m203.5 277.21h105v15h-105z"
}));

var SvgLoveLetterMenu = function SvgLoveLetterMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoveLetterMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/love-letter-menu.c2a19d6e.svg";
export { ForwardRef as ReactComponent };